<template>
  <div
    class="wrapper"
    @click="$emit('handleClick')">
    <div class="wrapper__icon">
      <v-icon
        color="white"
        size="70">
        mdi-plus
      </v-icon>
    </div>
    <p class="wrapper__title">
      {{ btnTitle }}
    </p>
  </div>
</template>
<script>
export default {
  name: 'AppCreateObjBtn',
  props: {
    btnTitle: {
      type: String,
      default: 'Create...',
    },
  },
};
</script>
<style scoped lang="scss">
.wrapper {
  margin-bottom: 24px;
  &:hover {
    opacity: 0.9;
    cursor: pointer;
  }
  &__icon {
    border-radius: 15px;
    background: linear-gradient(270deg, #71D6E0 -42.03%, #0AA8DA 134.48%);
    height: 120px;
    width: 120px;
    margin: 20px 20px 4px 20px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .v-icon {
    &::before {
      font-weight: 600;
    }
  }
  &__title {
    margin-bottom: 0;
    text-align: center;
  }
}
</style>
